// JS
import './jquery.init'
import './scripts/bootstrap/bootstrap.bundle'
import 'jquery-ui/ui/widget' // base module for all jquery-ui widgets

// CSS
import 'bootstrap/dist/css/bootstrap.min.css'
import './css/inputs.css'
import './css/select-controls.css'
// import 'tf-design-system'
// vue
import Vue from 'vue'
Vue.config.productionTip = false

// initializers
import getUIInitializer from './ui/bar'
import getSEInitializer from './libs/se'
import getStoreInitializer from './store'

// init
import initBundles from './init'

// events
import Events from 'tf-events-1'

// types
import { AttachStoreToBundle, CreateUI, InitBundles, SEBundle, SubinitSE } from "./types/types"

const getBundle = (): SEBundle => {
    const events = Events()

    const bundle: SEBundle = {
        init: {
            ui: {
                bar: null
            },
            libs: {
                se: null
            },
            store: null
        },

        // store
        store: null
    }

    const seInitializer: SubinitSE = getSEInitializer({ bundle, events })
    const uiInitializer: CreateUI = getUIInitializer({ bundle, events })
    const storeInitializer: AttachStoreToBundle = getStoreInitializer({ bundle, events })

    bundle!.init!.libs!.se = seInitializer
    bundle!.init!.ui!.bar = uiInitializer
    bundle!.init!.store = storeInitializer

    return bundle
}

type SE = {
    [key: string]: any
    getBundle: () => SEBundle;
    init: InitBundles;
}


// global
if (!window.tf) window.tf = {}
if (!window.tf.bundles) window.tf.bundles = {}
if (!window.tf.bundles.se) {
    console.log(`no se, creating`)
    const se: SE = {
        getBundle,
        init: initBundles
    }
    window.tf.bundles.se = se
}